export const messageHistoryCopyEs = {
    title: "Historial de mensajes",
    noMessages: "Ningún mensaje encontrado",
    viewMessages: "Ver los mensajes",
    to: "Para:",
    from: "De:",
    subject: "Asunto:",
    statusClicked: "Pulsado",
    statusRead: "Leído",
    statusReadAt: "a las",
    statusDelivered: "Entregado",
    statusSent: "Enviado",
    statusPending: "Pendiente",
    channelEmail: "E-mail",
    channelSms: "SMS",
    retentionNotice: "Los mensajes solo se conservan durante 30 días",
};
